import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import  { SetInitialBalanceView } from "./setInitialBalance-view"

export class SetInitialBalanceViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تعیین موجودی اولیه';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.lineItems = ObservableArray.create<lineItem>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.warehouseSelector = new WarehouseSelector(this);
        this.warehouseSelector.onSelectionChanged = w =>{
            this.warehouseId = w.id;
            this.warehouseName = w.title;
            this.refresh();
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new SetInitialBalanceView();
    }
    public getTypeId(): string {
        return "VM-750A4245-D44B-48D3-86F2-7C9EF6E9846E"
    }

    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;

    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryServices/ListAllProductsWithTheirReorderPoint',{
                FurtherQueryInfo:filteringInformation,
                WarehouseId : this.warehouseId
            });
            this.lineItems.update(...result.Products.map(q=>{
                let r = new lineItem(this);
                r.measuredProductId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.unitName = q.UnitName;
                r.balance = q.Balance;
                r.availableBalance = q.AccessibleBalance;
                r.newBalance = q.Balance;
                r.newAccessibleBalance = q.AccessibleBalance;
                r.isEdited = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async save(item:lineItem){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/InventoryServices/SetWarehouseInitialBalance',{
                Balances:[{
                    WarehouseId : this.warehouseId,
                    MeasuredProductId:item.measuredProductId,
                    Balance:item.newBalance,
                    AvailableBalance:item.newBalance
                }]
            });
        } catch (ex) {
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }
}

export class lineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:SetInitialBalanceViewModel) {
        super(parent);
        this.typedParent = parent;
    }
    private typedParent : SetInitialBalanceViewModel;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance;} private _availableBalance: number;
    public set newBalance(v: number) { 
        this._newBalance = getAsNumber(v,true); 
        this.isEdited = true;
    } public get newBalance(): number { return this._newBalance;} private _newBalance: number;
    
    public set newAccessibleBalance(v: number) { 
        this._newAccessibleBalance = getAsNumber(v,true); 
        this.isEdited = true;; 
    } public get newAccessibleBalance(): number { return this._newAccessibleBalance;} private _newAccessibleBalance: number;
    
    public set isEdited(v: boolean) { this._isEdited = v; } public get isEdited(): boolean { return this._isEdited;} private _isEdited: boolean;
    
    async confirm(){
        let confirmation ='';
        confirmation = await this.messageBoxWarningYesNo('آیا مقدار موجودی تعیین شود؟','تعیین موجودی اولیه');
        if(confirmation=='no'){
            return;
        }
        try {
            await this.typedParent.save(this);
            this.balance = this.newBalance;
            this.availableBalance = this.newBalance;
            this.isEdited = false;
            await this.messageBoxConfirmSuccess('.تعیین موجودی با موفقیت انجام شد','تعیین موجودی');
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
}